import classNames from 'classnames';
import React, { forwardRef } from 'react';

const StickyHeader = forwardRef<
  HTMLHeadingElement,
  { className?: string; isCollapsible?: boolean; children: React.ReactNode }
>(({ className, isCollapsible, children }, ref) => {
  const headerClassName = classNames({
    header: true,
    'header-fixed': true,
    'header-collapsible': isCollapsible,
    'header-collapsible-visible': isCollapsible,
    [className ?? '']: className,
  });

  return (
    <header ref={ref} className={headerClassName}>
      {children}
    </header>
  );
});
export default StickyHeader;
